export default function dropdownCloseFix() {
  $('.dropdown-menu').on('click', (e) => {
    const close = e.target.closest('button')?.dataset?.dismiss;
    if (close === 'modal') {
      $('.dropdown-menu').dropdown('dispose');
    } else {
      e.stopPropagation();
    }
  });
}
